import React, { Component } from "react"
import OutsideClickTrigger from "../../booking/components/common/OutsideClickTrigger"
import Svg from "../_svgs/svg"
import * as cookieHelper from "../../helpers/cookie"
import * as tracking from "../../helpers/tracking"
import * as dataProvider from "../../typeahead/helpers/dataProvider"
import reactStringReplace from "react-string-replace"
import ReactHtmlParser from "react-html-parser"
import { isSafari } from "react-device-detect"

export default class SearchSection extends Component {
  constructor(props) {
    super(props)

    this.state = {
      searchQuery: "",
      totalCount: 0,
      filteredData: {},
      displayGroupNames: [],
    }
    this.trackingTimeoutId = null
    this.inputRef = React.createRef()
  }

  componentDidMount() {
    this.focusInput()

    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty("--vh", `${vh}px`)
    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty("--vh", `${vh}px`)
    })
  }

  componentDidUpdate() {
    if (window.innerWidth >= 950) {
      // modal threshold/on desktop view
      this.focusInput()
    }
  }

  focusInput() {
    if (this.props.isSearchActive) {
      const input = document.querySelector(".searchinput")
      if (input) {
        input.focus()
      }
    }
  }

  handleSearchClose = (closeHandler) => {
    this.setState({ totalCount: 0, searchQuery: "", filteredData: {}, displayGroupNames: [] }, () => {
      if (closeHandler) closeHandler()
    })
  }

  handleInput = (event) => {
    const name = event.target.name
    const value = event.target.value
    if (this.inputRef.current === document.activeElement && this.inputRef.current.value.length > 1 && (event.key === 13 || event.key === "Enter")) {
      window.location.href = this.state.searchUrl
    }

    this.setState({ [name]: value }, () => {
      this.performSearch(value, true)
    })
  }

  performSearch = async (query, track = true) => {
    const response = await dataProvider.getData(query)

    if (this.trackingTimeoutId) {
      clearTimeout(this.trackingTimeoutId)
    }

    if (response && response.data) {
      const data = dataProvider.createPageData(response.data, this.props.searchConfig, track, "site search - generic", query)
      const { filteredData, displayGroupNames, totalCount } = data
      this.setState({ filteredData, displayGroupNames, totalCount })
    } else {
      const data = dataProvider.createPageData({}, this.props.searchConfig, track, "site search - generic", query)
      const { filteredData, displayGroupNames, totalCount } = data
      this.setState({ filteredData, displayGroupNames, totalCount })
    }
    this.trackingTimeoutId = setTimeout(() => {
      tracking.trackSearchInteraction(cookieHelper.getUserId(this.props), query)
    }, 200)
  }

  resultsReplace = (text, query, count) => {
    let newtext = text || ""
    if (query) newtext = newtext.replace("{{searchQuery}}", query)
    if (count) newtext = newtext.replace("{{count}}", count)
    return newtext
  }

  renderSearchButton = (isZeroState, searchQuery, totalCount) => {
    const { searchConfig } = this.props
    let buttonText =
      isZeroState || totalCount === 0
        ? searchConfig.texts.searchButton.defaultText
        : this.resultsReplace(searchConfig.texts.searchButton.resultsText, searchQuery, totalCount)
    let searchUrl = isZeroState || totalCount === 0 ? searchConfig.siteSearchUrl : `${searchConfig.siteSearchUrl}?query=${searchQuery}&c=global*`
    // if (searchUrl != this.state.searchUrl) this.setState({ searchUrl: searchUrl })

    return (
      <div className="buttoncontainer">
        <a tabIndex={this.props.isSearchActive ? 0 : -1} href={searchUrl} className={`button button--medium button--general no-shadow`}>
          <span className="text">{buttonText}</span>
        </a>
      </div>
    )
  }

  render() {
    const { searchConfig } = this.props
    const { searchQuery, filteredData, totalCount } = this.state
    let data = filteredData || {}

    const top = searchConfig.sectionData ? searchConfig.sectionData.searchSectionTop : []
    const middle = searchConfig.sectionData ? searchConfig.sectionData.searchSectionMiddle : []
    const bottom = searchConfig.sectionData ? searchConfig.sectionData.searchSectionBottom : []
    const isZeroState = searchQuery.length <= 1

    if (isZeroState) {
      data = searchConfig.zeroState.data || {}
    }

    const searchFieldPlaceholder = searchConfig.zeroState.searchFieldPlaceholder

    return (
      <div className={`search-section ${isSafari ? "safari-only" : ""} ${this.props.isSearchActive ? "is-active" : ""}`}>
        <OutsideClickTrigger onOutsideClick={() => this.handleSearchClose(this.props.handleOutsideClick)}>
          <div className={`search-section__content`}>
            <div className="input-wrapper">
              <input
                ref={this.inputRef}
                tabIndex={this.props.isSearchActive ? 0 : -1}
                className="searchinput"
                type="text"
                name={"searchQuery"}
                placeholder={searchFieldPlaceholder || "Søg"}
                value={this.state.searchQuery}
                onChange={(e) => this.handleInput(e)}
                onKeyDown={(e) => (e.key === 13 || e.key === "Enter" ? this.handleInput(e) : null)}
              ></input>
              <div className="icon-wrapper">
                <div
                  tabIndex={this.props.isSearchActive ? 0 : -1}
                  className="closeicon"
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      e.preventDefault()
                      this.handleSearchClose(this.props.closeHandler)
                      return
                    }
                  }}
                  onClick={() => this.handleSearchClose(this.props.closeHandler)}
                >
                  <Svg iconName={"close"} fillColor={"#333333"} />
                </div>
              </div>
            </div>

            <Section
              searchConfig={this.props.searchConfig}
              totalCount={totalCount}
              data={data}
              isZeroState={isZeroState}
              section={top}
              sectionName={"searchSectionTop"}
              className={"top"}
              isSearchActive={this.props.isSearchActive}
              resultsReplace={this.resultsReplace}
              searchQuery={searchQuery}
            />

            <Section
              searchConfig={this.props.searchConfig}
              data={data}
              isZeroState={isZeroState}
              section={middle}
              sectionName={"searchSectionMiddle"}
              className={"middle"}
              isSearchActive={this.props.isSearchActive}
              resultsReplace={this.resultsReplace}
              searchQuery={searchQuery}
            />

            <Section
              searchConfig={this.props.searchConfig}
              data={data}
              isZeroState={isZeroState}
              section={bottom}
              sectionName={"searchSectionBottom"}
              className={"bottom"}
              isSearchActive={this.props.isSearchActive}
              resultsReplace={this.resultsReplace}
              searchQuery={searchQuery}
            />

            {this.renderSearchButton(isZeroState, searchQuery, totalCount)}
          </div>
        </OutsideClickTrigger>
      </div>
    )
  }
}

class Section extends Component {
  renderItem = (elem, key, className) => {
    return (
      <a tabIndex={this.props.isSearchActive ? 0 : -1} href={elem.url} key={key} className={className}>
        {elem.icon ? (
          <div className="icon">
            <Svg iconName={elem.icon} />
          </div>
        ) : (
          ""
        )}
        <div className="text">{elem.name}</div>
        {elem.displayGroupName ? <span className="category">{elem.displayGroupName}</span> : ""}
      </a>
    )
  }

  hasData(section, data, isZeroState = false) {
    let tempData = data
    if (data && Object.keys(data).length > 0) {
      return section.some((element) => {
        if (tempData[element] && tempData[element].length > 0) {
          if (isZeroState) {
            return true
          } else {
            return false
          }
        }
        if ((tempData[element] && tempData[element].count > 0) || (tempData[element] && tempData[element].docs.length > 0)) {
          if (tempData[element].docs.some((element) => element.isZeroData) && !isZeroState) {
            return false
          } else {
            return true
          }
        }
        return false
      })
    }
    return false
  }

  renderResults = (section, data) => {
    const { searchConfig, searchQuery, sectionName } = this.props
    const { texts, shopSearchUrl, arrivalsSearchUrl, departuresSearchUrl, maxResults } = searchConfig
    const { arrivals, departures, taxFree } = texts
    if (section && section.length > 0) {
      let topItemCount = 0
      return section.map((group) => {
        let url, item
        const results = data[group].docs
        const count = data[group].count
        if (count < 1) return ""
        const displayGroupName = data[group].displayGroupName
        switch (group) {
          case "ProductsTypeahead":
          case "CategoryTypeahead":
          case "BrandsTypeahead":
            if (sectionName === "searchSectionTop") {
              topItemCount++
              if (topItemCount > maxResults) return
            }
            url = `${shopSearchUrl}?q=${searchQuery}&c=shop*`
            item = this.getItem(url, searchQuery, taxFree.searchResultText, count, "shoppingbag-new")
            return this.renderItem(item, group, "item")
          case "DepartureTypeahead":
            if (sectionName === "searchSectionTop") {
              topItemCount++
              if (topItemCount > maxResults) return
            }
            url = `${departuresSearchUrl}?q=${searchQuery}`
            item = this.getItem(url, searchQuery, departures.searchResultText, count, "planetakeoff")
            return this.renderItem(item, group, "item")
          case "ArrivalsTypeahead":
            if (sectionName === "searchSectionTop") {
              topItemCount++
              if (topItemCount > maxResults) return
            }
            url = `${arrivalsSearchUrl}?q=${searchQuery}`
            item = this.getItem(url, searchQuery, arrivals.searchResultText, count, "planelanding")
            return this.renderItem(item, group, "item")
          case "MerchantsTypeahead":
            return results.map((res, index) => {
              if (res.isZeroData) return
              if (sectionName === "searchSectionTop") {
                topItemCount++
                if (topItemCount > maxResults) return
              }
              const merchant = this.getItem(
                res.MerchantURL,
                searchQuery,
                `${res.Name} ${res.CustomLocationLabel_s || ""}`,
                null,
                null,
                res.DisplayGroupName_s || displayGroupName,
              )
              return this.renderItem(merchant, group + index, "item")
            })
          case "ArticleTypeahead":
            return results.map((res, index) => {
              if (res.isZeroData) return
              if (sectionName === "searchSectionTop") {
                topItemCount++
                if (topItemCount > maxResults) return
              }
              const article = this.getItem(res.PageUrl_s, searchQuery, res.Header_s, null, null, displayGroupName)
              return this.renderItem(article, group + index, "item")
            })
        }
      })
    }
    return ""
  }

  getItem = (url, searchQuery, resultsText, count = null, icon = null, category = null) => {
    let text = resultsText
    if (icon) {
      if (searchQuery) text = text.replace("{{searchQuery}}", `<span>${searchQuery}</span>`)
      if (count) text = text.replace("{{count}}", count)
      text = ReactHtmlParser(text)
    } else {
      let resultText = this.props.resultsReplace(resultsText, searchQuery, count)
      text = this.stringReplace(resultText, searchQuery)
    }
    const item = { icon: icon, url: url, name: text }
    if (category) item.displayGroupName = category
    return item
  }

  stringReplace = (text, input) => {
    const words = input.split(" ").filter(Boolean)
    const regex = new RegExp("(" + words.join("*|") + ")", "gi")
    return reactStringReplace(text, regex, (match, i) => <span key={match + i}>{match}</span>)
  }

  render() {
    const { section, data, isZeroState, className, searchConfig, searchQuery } = this.props

    // render no results
    if (this.props.totalCount && this.props.totalCount === 0 && searchQuery.length > 1) {
      const resultText =
        searchConfig.noResults?.replace("{{searchQuery}}", `<span>${searchQuery}</span>`) || "Ingen resultater matchede {{searchQuery}}"
      return (
        <div className={className}>
          <div className={"item"}>
            <div className={"text"}>{ReactHtmlParser(resultText)}</div>
          </div>
        </div>
      )
    }
    return this.hasData(section, data, isZeroState) ? (
      <div className={className}>
        {isZeroState
          ? section.map((group) => {
              const sectionData = data[group]
              if (sectionData) {
                return (
                  <div key={group}>
                    {sectionData.length > 0 &&
                      sectionData.map((elem, index) => {
                        return this.renderItem(elem, index, "item")
                      })}
                  </div>
                )
              } else {
                return
              }
            })
          : this.renderResults(section, data)}
      </div>
    ) : (
      ""
    )
  }
}
